var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02944 0 0 4.02944 0 9V10.8C0 11.7941 0.805888 12.6 1.8 12.6H3.6C3.93137 12.6 4.2 12.3314 4.2 12V8.4C4.2 8.06863 3.93137 7.8 3.6 7.8H1.2375C1.82742 4.37146 4.81103 1.8 8.4 1.8H9.6C13.189 1.8 16.1726 4.37146 16.7625 7.8H14.4C14.0686 7.8 13.8 8.06863 13.8 8.4V12C13.8 12.3314 14.0686 12.6 14.4 12.6H16.2V13.2C16.2 14.1941 15.3941 15 14.4 15H10.8C10.4686 15 10.2 15.2686 10.2 15.6V17.4C10.2 17.7314 10.4686 18 10.8 18H14.4C16.3882 18 18 16.3882 18 14.4V9C18 4.02944 13.9706 0 9 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 8.4C6.3 8.06863 6.56863 7.8 6.9 7.8H11.1C11.4314 7.8 11.7 8.06863 11.7 8.4C11.7 8.73137 11.4314 9 11.1 9H6.9C6.56863 9 6.3 8.73137 6.3 8.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.093933db.svg";
export { ForwardRef as ReactComponent };